import Component from '@component';
import FixScroll from '@utils/html/FixScroll';
import creator from '@utils/creator';
import Device from '@utils/html/Device';
import {breakpointsApp} from '../../colorz/configClrzApp';
import PredictiveSearch from './PredictiveSearch';

export default class Header extends Component {
	onInit(el) {
		this.el = el;
		this.menuPanel = this.el.querySelector('.js-nav-panel');

		this.closePanelBtn = this.el.querySelector('.js-nav-close');
		this.openPanelBtn = this.el.querySelector('.js-nav-open');
		this.mainNav = this.el.querySelector('.js-main-nav');
		this.headerMainLink = this.el.querySelectorAll('.js-header-main-link');

		this.main = document.querySelector('main');
		this.root = document.documentElement;
		this.announcementBar = document.querySelector('.js-announcement-bar');
		if (this.announcementBar) {
			this.heightAnnouncementBar = this.announcementBar.offsetHeight;
		} else {
			this.heightAnnouncementBar = 0;
		}

		this.headerHeightMobile = this.heightAnnouncementBar + this.el.offsetHeight;

		this.isMobile = Device.width < breakpointsApp.desktop;

		if (this.isMobile) {
			this.headerHeight = this.headerHeightMobile;
			this.mainNav.setAttribute('tabindex', -1);
		} else {
			this.headerHeight = this.el.offsetHeight;
		}

		this.root.style.setProperty(
			'--header-height-mobile',
			this.headerHeightMobile + 'px',
		);
		this.root.style.setProperty(
			'--height-announcement-bar',
			this.heightAnnouncementBar + 'px',
		);

		this.isMobile = Device.width < breakpointsApp.desktop;
		this.open = false;

		this.PredictiveSearch = creator('.js-predictive-search', PredictiveSearch);

		this.onScroll = this.onScroll.bind(this);
		this.openPanel = this.openPanel.bind(this);
		this.closePanel = this.closePanel.bind(this);
	}

	onReady() {
		this.bindEvents();
	}

	bindEvents() {
		this.onResize();
		this.onScroll();

		this.openPanelBtn.addEventListener('click', () => {
			if (this.open == false) {
				this.openPanel();
			} else {
				this.closePanel();
			}
		});

		this.mainNav.addEventListener('mouseenter', () => {
			this.closeDesktopSubmenu();
		});
		this.mainNav.addEventListener('focus', () => {
			this.closeDesktopSubmenu();
		});
		this.mainNav.addEventListener('mouseleave', () => {
			if (this.mainNav.querySelector('.l-header__main-link.remove-hover')) {
				this.mainNav
					.querySelector('.l-header__main-link.remove-hover')
					.classList.remove('remove-hover');
			}
		});

		this.managedAttributesMenuDesktop();
	}

	onResize() {
		this.height = window.innerHeight;
		document.documentElement.style.setProperty('--vh', `${this.height}px`);
	}

	onScroll() {
		if (FixScroll.state || (this.isScrollFixed && !FixScroll.state)) {
			this.isScrollFixed = FixScroll.state;
			return;
		}
		this.stickyHeader();
	}

	openPanel() {
		this.open = true;
		document.querySelector('.js-predictive-search-open-mobile').focus();
		this.menuPanel.classList.add('panel-is-open');
		this.mainNav.setAttribute('aria-expanded', 'true');
		document.querySelector('.js-predictive-search-close').click();
		FixScroll.fix();
		this.openPanelBtn.setAttribute('aria-expanded', 'true');
		this.menuPanel.setAttribute('aria-hidden', 'false');
		const containerToTrapFocusOn = document.querySelector(
			'.js-header-panel-container',
		);
		const focusElement = document.querySelector('.js-header-panel-content');
		trapFocus(containerToTrapFocusOn, focusElement);

		document.body.addEventListener('keydown', (e) => {
			if (e.key == 'Escape') {
				this.closePanel();
				this.openPanelBtn.focus();
			}
		});
	}

	closePanel() {
		this.open = false;
		this.menuPanel.classList.remove('panel-is-open');
		document.querySelector('.js-predictive-search-close').click();
		FixScroll.unFix();
		this.openPanelBtn.setAttribute('aria-expanded', 'false');
		this.menuPanel.setAttribute('aria-hidden', 'true');
		removeTrapFocus();
	}

	stickyHeader() {
		const sticky = this.el.offsetTop;

		if (Device.scroll.direction == 'up' && window.pageYOffset > sticky) {
			this.el.classList.add('is-sticky');
			this.root.style.setProperty('--header-margin', this.headerHeight + 'px');

			if (this.isMobile && this.announcementBar) {
				this.announcementBar.classList.add('is-sticky');
			}
		} else {
			this.el.classList.remove('is-sticky');
			this.root.style.setProperty('--header-margin', '0px');

			if (this.isMobile && this.announcementBar) {
				this.announcementBar.classList.remove('is-sticky');
			}
		}
	}

	closeDesktopSubmenu() {
		document.body.addEventListener('keydown', (e) => {
			if (e.key == 'Escape') {
				if (this.mainNav.querySelector('.l-header__main-link:hover')) {
					this.mainNav
						.querySelector('.l-header__main-link:hover')
						.classList.add('remove-hover');
					this.mainNav.setAttribute('aria-expanded', 'false');
				} else if (
					this.mainNav.querySelector('.l-header__main-link:focus-within')
				) {
					this.mainNav
						.querySelector('.l-header__main-link:focus-within')
						.classList.add('remove-hover');
					this.mainNav.setAttribute('aria-expanded', 'false');
				}
			}
		});
	}

	managedAttributesMenuDesktop() {
		this.headerMainLink.forEach((element) => {
			element.addEventListener('mouseenter', () => {
				if (!element.querySelector('.js-menu-list')) return;
				element.setAttribute('aria-expanded', 'true');
			});
			element.addEventListener('mouseleave', () => {
				element.setAttribute('aria-expanded', 'false');
			});

			document.body.addEventListener('keydown', (e) => {
				if (e.key == 'Escape') {
					element.setAttribute('aria-expanded', 'false');
				}
			});
		});
	}
}
